import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../api";
import { useLang } from "../i18n";

const inputCls =
  "w-full bg-[#0D0F16] border border-white/10 rounded-xl px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:border-[rgba(68,153,247,0.5)] focus:ring-1 focus:ring-[rgba(68,153,247,0.3)] transition-colors";

export default function EnquiryForm({ vehicle = null, testPrefix = "contact" }) {
  const { t } = useLang();
  const part = new URLSearchParams(window.location.search).get("part");
  const subject = vehicle || (part ? { id: null, title: part } : null);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: part && !vehicle ? `${t("dz.prefill")}: ${part}\n` : "",
  });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/enquiries", {
        ...form,
        vehicle_id: subject?.id || null,
        vehicle_title: subject?.title || null,
      });
      toast.success(t("form.sent"));
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err) || t("form.error"));
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid={`${testPrefix}-form`} onSubmit={submit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          data-testid={`${testPrefix}-form-name-input`}
          required
          value={form.name}
          onChange={set("name")}
          placeholder={t("form.name")}
          className={inputCls}
        />
        <input
          data-testid={`${testPrefix}-form-phone-input`}
          required
          value={form.phone}
          onChange={set("phone")}
          placeholder={t("form.phone")}
          className={inputCls}
        />
      </div>
      <input
        data-testid={`${testPrefix}-form-email-input`}
        required
        type="email"
        value={form.email}
        onChange={set("email")}
        placeholder={t("form.email")}
        className={inputCls}
      />
      <textarea
        data-testid={`${testPrefix}-form-message-input`}
        required
        rows={5}
        value={form.message}
        onChange={set("message")}
        placeholder={subject ? `${t("form.message")} — ${subject.title}` : t("form.messagePh")}
        className={`${inputCls} resize-none`}
      />
      <button
        data-testid={`${testPrefix}-form-submit-btn`}
        type="submit"
        disabled={sending}
        className="w-full sm:w-auto bg-[#4499F7] text-[#0A0B10] font-semibold text-sm rounded-full px-8 py-3.5 hover:bg-[#6FB1FA] disabled:opacity-60 transition-colors"
      >
        {sending ? t("form.sending") : t("form.send")}
      </button>
    </form>
  );
}
